import { useState } from 'react'

import { webPushStrings } from '../../constants/strings'
import { useWebPush } from '../../hooks/useWebPush'
import { DismissibleBanner } from '../DismissibleBanner'

function BellIcon() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  )
}

type EnableNotificationsBannerProps = {
  /** 運営の認証が完了してから true にする（認証前は描画しない）。 */
  enabled: boolean
}

/**
 * Web Push 対応ブラウザでオプトインを提示するバナー。
 * ボタンクリックが、iOS が許可プロンプトに要求するユーザージェスチャーとなる。
 */
export function EnableNotificationsBanner({
  enabled,
}: EnableNotificationsBannerProps) {
  const { shouldOffer, status, enable } = useWebPush(enabled)
  const [dismissed, setDismissed] = useState(false)

  if (!shouldOffer || dismissed) return null

  const isSubscribing = status === 'subscribing'
  const isError = status === 'error'
  const buttonLabel = isSubscribing
    ? webPushStrings.enabling
    : isError
      ? webPushStrings.retryButton
      : webPushStrings.enableButton

  return (
    <DismissibleBanner
      icon={<BellIcon />}
      title={webPushStrings.enableTitle}
      description={webPushStrings.enableDescription}
      dismissLabel={webPushStrings.dismissLabel}
      onDismiss={() => setDismissed(true)}
    >
      {isError && (
        <p role="alert" className="mt-1 font-medium text-danger">
          {webPushStrings.enableError}
        </p>
      )}
      <button
        type="button"
        onClick={() => {
          void enable()
        }}
        disabled={isSubscribing}
        className="mt-2 inline-flex items-center rounded-lg bg-accent px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-accent/90 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {buttonLabel}
      </button>
    </DismissibleBanner>
  )
}
